import React, { Component } from 'react'
import './FileList.less'
import { appMethod as app } from '@utils/app';
import { Toast } from 'antd-mobile';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { ajax } from '@utils/http';

const fileIcons = {
  pdf: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term7.png',
  doc: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term8.png',
  ppt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term9.png',
  txt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term10.png',
  excel: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term11.png',
 }

export default class FileList extends Component {


   state = {
    filesList:[],
   }

   constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.fileUploadBoxRef = React.createRef();
  }

  componentDidMount(){
  }
  componentWillUnmount() {

  }
  // 上传文件
  iconUploadFiles = () => {
    console.log(app.globalData.sessionKey);
    if (this.fileInputRef.current && this.state.filesList.length < 10) {
      this.fileInputRef.current.click();
    }
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    console.log(this.fileUploadBoxRef.current);
    this.fileUploadBoxRef.current.classList.add('dragging');
  }
  handleDragLeave = (e) => {
    e.preventDefault();
    this.fileUploadBoxRef.current.classList.remove('dragging');
  }
  handleDragOver = (e) => {
    e.preventDefault();  // 阻止默认的处理，允许文件拖拽
  }

  handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;  // 获取拖拽的文件
    this.fileUploadBoxRef.current.classList.remove('dragging');
    if (files.length) {
      // 将文件传递给 uploadFiles 方法处理上传
      this.uploadFiles({ target: { files: files } });
    }
  }

  // 类型检验
  getFileType = (mimeType) => {
    const typeMap = {
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
      'application/pdf': 'pdf',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
      'text/plain': 'txt',
      'application/vnd.ms-excel': 'excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
      'image/jpeg': 'image',
      'image/png': 'image'
      };
      
      return typeMap[mimeType] || mimeType;
  }
  getFileSize = (sizeInBytes) => {
      if (sizeInBytes < 1024) {
        return `${sizeInBytes} B`;
      } else if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(2)} KB`;
      } else {
        return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
      }
    }

  uploadFiles = async (e) => {
    const files = e.target.files;
    const currentFiles = this.state.filesList
    const maxFileSize = 20 * 1024 * 1024; // 20MB
    const maxFiles = 10;

    if (!files.length) {
      return;
    }

    // 检查文件数量
    if (files.length + currentFiles.length > maxFiles) {
      Toast.info(`最多只能上传${maxFiles}个文件！`);
      return;
    }


    // 检查每个文件的大小和类型，并返回详细信息
    const validTypes = new Set([
      'image/jpeg', 'image/png', 'application/msword', 
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
      'application/pdf', 'application/vnd.ms-powerpoint', 
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'text/plain'
    ]);

    const fileDetails = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxFileSize) {
        Toast.info(`${file.name} 大小超过20MB，无法上传。`);
        continue;
      }

      if (!validTypes.has(file.type)) {
        Toast.info(`${file.name} 类型不支持，无法上传。`);
        continue;
      }

      const type = this.getFileType(file.type);
      const size = this.getFileSize(file.size);

      const fileDetail = {
        name: file.name,
        type: type,
        size: size,
        url: '',
        status: 1
      };

      fileDetails.push(fileDetail);
    }

    this.setState({
      filesList: currentFiles.concat(fileDetails)
    });

    await Promise.all(fileDetails.map(async (fileDetail, index) => {
      const file = files[index];
      try {
        if (fileDetail.type !== 'image') {
          ajax({
            url: '/index.php?r=ChatAI/UploadFile',
            data: {
              name: file
            },
            success: (res) => {
              if (res.status === 0) {
                fileDetail.url = res.data;
                fileDetail.status = 2;
              } else {
                fileDetail.url = '';
                fileDetail.status = 3;
              }
              currentFiles.push(fileDetail)
              this.setState({
                filesList: currentFiles
              });              
            }
          });
        } else {
          const result = await lrz(file);
          ajax({
            url: '/index.php?r=AppData/uploadImg',
            data: {
              img_data: result.base64,
              org: 1
            },
            success: (res) => {
              if (res.status === 0) {
                fileDetail.url = res.data;
                fileDetail.status = 2;
              } else {
                fileDetail.url = '';
                fileDetail.status = 3;
              }
              currentFiles.push(fileDetail)
              this.setState({
                filesList: currentFiles
              });
            }
          });
        }
      } catch (error) {
        fileDetail.url = '';
        fileDetail.status = 3;
        currentFiles.push(fileDetail)
        this.setState({
          filesList: currentFiles
        });
      }
    }));
  }

  // 删除
  deleteFile = (index)=>{
    app.showModal({
      content: '确定要删除该文件吗?',
      showCancel: true,
      confirmColor: '#437eff',
      cancelColor: '#437eff',
      confirm: () => {
        this.setState(prevState => ({
          filesList: prevState.filesList.filter((_, i) => i !== index)
        }));
      },
    })
  }
  //  取消
  cancel = () => {
    this.props.cancelDialog('fileDialogShow');
  }
  // 确定
  comfirmFile = () => {
    if( this.state.filesList.length === 0 ){
      Toast.info('请选择文件');
      return
    }
    const filteredFiles = this.state.filesList.filter(item => item.status === 2);
    let filesInfo = [];
    filteredFiles.forEach(item => {
      filesInfo.push({
        type: item.type !== 'image' ? 'corpus_file' : 'image',
        name: item.name,
        file_url: item.url,
        size: item.size,
        file_type: item.type,
      })
    });
    const filesListJson = JSON.stringify(filesInfo);
    app.sendRequest({
      url: '/index.php?r=ChatAI/Upload2User',
      data: {
        app_id: app.getAppId(),
        session_key: '',
        multi_files:filesListJson,
        role_id:-1
      },
      hideLoading: true,
      method: 'POST',
      success:(res) => {
        if(res.status == 0){
          Toast.success('文件上传成功');
        }else{
          Toast.fail('文件上传失败');
        }
        this.props.comfirmDialog();
      }
    })
  }

  render(){
    let { filesList} = this.state;
    return (
      <div className="filelist">
          <div className='mask' onClick={this.cancel}></div>
          <div className='content'>
            <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
            <div className='title'>文件上传</div>
            <div className='file_upload_box' ref={this.fileUploadBoxRef} onDragOver={this.handleDragOver} onDrop={this.handleDrop}  onDragEnter={this.handleDragEnter}
            onDragLeave={this.handleDragLeave}>
              <img className={( filesList.length > 1 ? 'disabled' : '') } onClick={ this.iconUploadFiles } src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term12.png" alt="tooltip-icon" />
              <div className={`file_title ${filesList.length > 1 ? 'disabled' : ''}`} onClick={ this.iconUploadFiles }>点击上传或拖拽图片到这里</div>
              <div className={`file_warm ${filesList.length > 1 ? 'disabled' : ''}`} onClick={ this.iconUploadFiles }>支持上传文件(最多10个，每个20 MB)。接受 pdf、doc、ppt、txt、excel、图片等</div>
              <input type="file" disabled={ filesList.length > 9 } ref={this.fileInputRef}  id="fileInput" multiple accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.txt" onChange={ this.uploadFiles } />
            </div>
            <div className="file_list_box">
              {filesList.map((item,index)=>
              <div className="file_box1" key={index}>
                <div className="file_lf">
                   {
                      item.status === 1 && (
                      <div className='file_loading'>
                        <img className='icon_file' src="https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_file_loading.png" alt="" />
                        <div className="loading-spinner"></div>
                      </div>
                      )
                    }
                    {
                      item.status === 2 && item.type === 'image' &&
                      <img className='icon_file' src={ item.url } alt="" />
                    }
                    {
                      item.status === 2 && item.type !== 'image' && fileIcons[item.type] && (
                        <img
                          className="icon_file"
                          src={`${fileIcons[item.type]}`}
                        />
                      )
                    }
                    {
                      item.status === 3 &&
                      <img className='icon_file' src={ 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + (item.type === 'image' ? 'img_fail.png' : 'file_fail.png') } alt="" />
                    }
                  <div className="file_cnt">
                    <span className='file_name'>{ item.name }</span>
                     { item.status === 1  &&
                      <span className='file_state'>上传中...</span>
                     }
                      { item.status === 2  &&
                        <span className='file_state'>{ item.type }，{ item.size }</span>
                      }
                      { item.status === 3  &&
                        <span className='file_state fail'>上传失败</span>
                      }
                  </div>
                </div>
                <div className="file_rf">
                    <Tooltip placement="top" overlay='删除' trigger={['hover']}>
                       <img  onClick={() => this.deleteFile(index)}  src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png" alt="tooltip-icon" />
                    </Tooltip>
                </div>
              </div>
              )}
            </div>
            <div className="file_btn">
               <div className="file_close" onClick={this.cancel}>取消</div>
               <div className="file_comfirm" onClick={this.comfirmFile}>确定</div>
            </div>
          </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/chatgpt-page/component/FileList/FileList.jsx